import {VueConstructor} from 'vue/types';
// Validation plugin used to validate forms
import '@/plugins/veeValidate';
// A plugin file where you could register global components used across the app
import GlobalComponents from "@/plugins/globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "@/plugins/globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import {NotificationPlugin} from "wings-ui-components";
// Tabs plugin. Used on Panels page.
import SidebarPlugin from "@/components/SidebarPlugin";

import VueMaterial from "vue-material";

// asset imports
import "vue-material/dist/vue-material.min.css";
import 'material-icons/iconfont/material-icons.css';
import "@/assets/theme.scss";


// library auto imports
import "es6-promise/auto";

export default {
  install(Vue: VueConstructor) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(VueMaterial);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationPlugin);
  }
};
